import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import settingsIcon from './ic-settings.svg';
import audioIcon from './audio-settings.svg';
import qualityIcon from './quality-settings.svg';
import { largeScreen, smallScreen } from '../../../../../common/mixins';
import platform, { OS_TYPES } from '../../../../../player/utils/platform';

const rules = ({ theme, disabled, isMobile }) => ({
  '&.settings-image-button': { // fix console global css
    cursor: 'pointer',
    marginRight: theme.margin.xlarge,
    opacity: theme.opacity.enabled,
    height: theme.iconHeight.large,
    transition: theme.transition.default,
    ':hover': {
      opacity: theme.opacity.hovered,
    },
    extend: [
      {
        condition: isMobile,
        style: {
          opacity: theme.opacity.hovered,
        },
      },
      largeScreen({
        height: theme.iconHeight.medium,
        marginRight: theme.margin.large,
      }),
      smallScreen({
        height: theme.iconHeight.small,
        marginRight: theme.margin.small,
      }),
      {
        condition: disabled,
        style: {
          cursor: 'not-allowed',
          opacity: theme.opacity.disabled,

          ':hover': {
            cursor: 'not-allowed',
            opacity: theme.opacity.disabled,
          },
        },
      },
    ],
  },
});

const SettingsButton = ({ onMouseEnter, onMouseLeave, onClick, disabled, isAudio, isQuality }) => {
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const { css } = useFela({ disabled, isMobile });
  const src = useMemo(() => {
    if (isAudio) return audioIcon;
    if (isQuality) return qualityIcon;
    return settingsIcon;
  }, [isAudio, isQuality]);

  return (
    <img
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      alt="player settings"
      className={`${css(rules)} settings-image-button`}
      src={src}
      data-cy="hp-settings-button"
    />
  );
};

SettingsButton.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isAudio: PropTypes.bool,
  isQuality: PropTypes.bool,
};

export default React.memo(SettingsButton);
